// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes AlertBox_fadeInOut__1cqWb {
    0% {
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
    90% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

.AlertBox_modal__\\+Xa5H {
    position: fixed; 
    top: 6px ; 
    left: 0;
    right: 0;
    display: flex;
    justify-content: center; 
    align-items: center;
    animation: AlertBox_fadeInOut__1cqWb 3.5s ease-in-out forwards;
    height: 120px;
    pointer-events: none;
    z-index: 100000000000;
  }

.AlertBox_window__RBCd4{
background-color: white;
max-width: 450px;
width: 100%;
height: 100%;
max-height: 180px;
border-radius: 7px; /* Закругление левого нижнего угла */
padding: 10px;
border: solid 1px #e2e2e2;
}

.AlertBox_components__ZmO4T {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  justify-content: center;
  text-align: center; /* Дополнительная центровка текста */
  width: 100%; /* При необходимости, чтобы контейнер занимал всю ширину */
}

@keyframes AlertBox_scaleInOut__WtCcH {
  0%, 100% { transform: scale(1); } 
  50% { transform: scale(1.2); } 
}

.AlertBox_icon__Wu8\\+U {
  width: 50px;
  height: 50px;
  animation: AlertBox_scaleInOut__WtCcH 1s ease-in-out;
}

.AlertBox_icon__Wu8\\+U ~ span{
   font-weight: 500;
   color: #303030;

}`, "",{"version":3,"sources":["webpack://./src/shared/Ui/AlertBox/AlertBox.module.css"],"names":[],"mappings":"AAAA;IACI;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;AAEF;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8DAA8C;IAC9C,aAAa;IACb,oBAAoB;IACpB,qBAAqB;EACvB;;AAEF;AACA,uBAAuB;AACvB,gBAAgB;AAChB,WAAW;AACX,YAAY;AACZ,iBAAiB;AACjB,kBAAkB,EAAE,oCAAoC;AACxD,aAAa;AACb,yBAAyB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,kBAAkB,EAAE,oCAAoC;EACxD,WAAW,EAAE,0DAA0D;AACzE;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoC;AACtC;;AAEA;GACG,gBAAgB;GAChB,cAAc;;AAEjB","sourcesContent":["@keyframes fadeInOut {\n    0% {\n      opacity: 0;\n    }\n    10% {\n      opacity: 1;\n    }\n    90% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0;\n    }\n  }\n\n.modal {\n    position: fixed; \n    top: 6px ; \n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: center; \n    align-items: center;\n    animation: fadeInOut 3.5s ease-in-out forwards;\n    height: 120px;\n    pointer-events: none;\n    z-index: 100000000000;\n  }\n\n.window{\nbackground-color: white;\nmax-width: 450px;\nwidth: 100%;\nheight: 100%;\nmax-height: 180px;\nborder-radius: 7px; /* Закругление левого нижнего угла */\npadding: 10px;\nborder: solid 1px #e2e2e2;\n}\n\n.components {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  justify-content: center;\n  text-align: center; /* Дополнительная центровка текста */\n  width: 100%; /* При необходимости, чтобы контейнер занимал всю ширину */\n}\n\n@keyframes scaleInOut {\n  0%, 100% { transform: scale(1); } \n  50% { transform: scale(1.2); } \n}\n\n.icon {\n  width: 50px;\n  height: 50px;\n  animation: scaleInOut 1s ease-in-out;\n}\n\n.icon ~ span{\n   font-weight: 500;\n   color: #303030;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `AlertBox_modal__+Xa5H`,
	"fadeInOut": `AlertBox_fadeInOut__1cqWb`,
	"window": `AlertBox_window__RBCd4`,
	"components": `AlertBox_components__ZmO4T`,
	"icon": `AlertBox_icon__Wu8+U`,
	"scaleInOut": `AlertBox_scaleInOut__WtCcH`
};
export default ___CSS_LOADER_EXPORT___;
